import {
  CheckboxController,
  Collapse,
  Divider,
  Text,
} from "@pushpress/shared-components";
import { useRef } from "react";
import { Control, Controller, useWatch } from "react-hook-form";
import { PlanForm } from "../PlanDrawer.types";
import { useExperiment } from "../../../../hooks/useExperiment";
import AppointmentsSection from "./AppointmentsSection";
import { PlanType } from "../../../../apis/subscriptionApi";
import { Input } from "@pushpress/pushpress-ui";

interface ClassesAdvancedOptionsCollapseProps {
  control: Control<PlanForm>;
  planType: PlanType;
}

const ClassesAdvancedOptionsCollapse = (props: ClassesAdvancedOptionsCollapseProps) => {
  const { control, planType } = props;
  const priorityBookingRef = useRef<HTMLDivElement>(null);
  const { useExperimentValue } = useExperiment();
  
  const priorityBookingFeatureFlag = useExperimentValue(
    "priority_booking_feature_flag",
    false
  );

  const [priorityBooking] = useWatch({
    control,
    name: ["priorityBooking"],
  });

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-wolf-200 tw-p-6 tw-mt-4 tw-relative">
      <Text 
        component="h2"
        variant="heading-5"
        weight="600"
        color="wolf-800"
        className="tw-mb-2">
          Advanced Access Settings
      </Text>
      <div className="tw-mb-6">
        {priorityBookingFeatureFlag && (
          <div>
            <CheckboxController
              control={control}
              name="priorityBooking"
              label="Priority Booking"
              className="mt-3"
            />
            <Text variant="body-md" color="wolf-600" className="mt-1">
              Enable this option if you want clients with this plan to be able to book
              prior to the class reservation window.
            </Text>
            <Collapse in={priorityBooking} ref={priorityBookingRef}>
              <div className="tw-grid tw-items-center tw-gap-1.5 tw-mt-3">
                <label htmlFor="priorityHoursInAdvance">
                  Hours in Advance *
                </label>
              </div>
              <Controller
                control={control}
                name="priorityHoursInAdvance"
                render={({ field }) => (
                  <Input
                    {...field}
                    type="number"
                    min={0}
                    autoComplete="off"
                    required
                    name="priorityHoursInAdvance"
                  />
                )}
              />
            </Collapse>
          </div>
        )}
        <div>
        <CheckboxController
            control={control}
            name="hybridAf"
            label="HybridAF (24-hr access)"
            className="mt-3"
          />
          <Text variant="body-md" color="wolf-600" className="mt-1">
              Enable this option if you want clients to receive 24-hour access to the facility.
          </Text>
        </div>
        {planType !== "session-pack" && (
          <>
            <Divider className="tw-mt-3" marginRight={-24} />
            <AppointmentsSection control={control} />
          </>
        )}
      </div>
    </div>
  );
};

export default ClassesAdvancedOptionsCollapse; 